import React from 'react';
import HeaderContainer from '../containers/header';
import AboutContainer from '../containers/about';
import ExperienceContainer from '../containers/experience';
import ProjectsContainer from '../containers/projects';
import ReviewsContainer from '../containers/reviews';
import CertificationsContainer from '../containers/certifications';
import FYPContainer from '../containers/fyp';
import FooterContainer from '../containers/footer';


export default function Home (props) {
    return (
        <div style={{position:"relative"}}>
            <HeaderContainer />
            <AboutContainer />
            <ExperienceContainer />
            <FYPContainer />
            <ProjectsContainer />
            <ReviewsContainer />
            <CertificationsContainer />
            <FooterContainer />
        </ div>
    )
}